<!-- EM_MO_SB_009  일반충전 -->
<template>
    <div class="stopusing-detail-wrap">
        <div class="stopusing-text-box">
            <strong>사용 중지 상태를</strong>
            <span>취소 하시겠습니까?</span>
        </div>
        <div class="stopusing-detail-top">
<!--          <img :src=this.prepaidCardImg>-->
            <span class="card-image-border-none" :style="{ backgroundImage:'url('+prepaidCardInfo.imageUrl+')'}"></span>
            <div>
                <em>{{ Number(prepaidCardInfo.remainCash).toLocaleString() }}</em>
                <strong>{{ prepaidCardInfo.prepaidCardNickName }}</strong>
                <span>구매일<small>{{ prepaidCardInfo.issueDate }}</small></span>
            </div>
        </div>
        <div class="fixed" @click="stopUsingCancelEvent()">
            <bottom-button class="button-style" :buttonArray="buttonArray"></bottom-button>
        </div>
      <alert-popup v-if="showAlertPopup === true" @confirmEvent="showAlertPopup = false" :message="alertMessage"></alert-popup>
      <stop-using-popup-cancel v-if="showStopUsingCancelPopup === true" @stopUsingCancelPopup="showStopUsingCancelPopup = false" :cardInfo="prepaidCardInfo"></stop-using-popup-cancel>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import StopUsingPopupCancel from "@/views/myemarticon/stopUsingCancelPopup.vue";
import api from "@/api/apiList";
import AlertPopup from './alertPopup.vue';

export default {
    name: 'StopUsingCancel',
    components: {StopUsingPopupCancel, AlertPopup, BottomButton },
    data() {
        // selectBoardList: <select-board></select-board> 컴포넌트에게 전달할 프롭스
        return {
            buttonArray : [
                {
                    className : "button-bg-yellow",
                    text : "사용 중지 취소",
                    // isDisabled: true,   
                },
            ],
          showStopUsingCancelPopup: false,
          prepaidCardInfo: {},
          showAlertPopup: false,
          alertMessage: '',
        }
    },
    mounted() {
      this.$heading('사용 중지 취소');
      console.log(this.$route.params.cardInfo)

      // 카드상세에서 넘겨받은 파라미터를 Vuex Store에 저장
      if(this.$route.params.cardInfo != null && this.$route.params.cardInfo !== undefined && this.$route.params.cardInfo !== ''){
        this.$store.commit('setPrepaidCardNo', this.$route.params.cardInfo.prepaidCardNo);
      }
      this.getPrepaidCardInfo();  //선불카드 정보 가져오기
    },
  methods: {
    //선불카드 정보 가져오기
    async getPrepaidCardInfo() {
      try {
        const res = await api.getPrepaidCard(null, { ctmmnyNo: this.$store.state.partnerId, prepaidCardNo: this.$store.state.prepaidCardNo });
        console.log(JSON.stringify("선불카드 가져온 정보:" + res.data.data));
        this.prepaidCardInfo = res.data.data;
          
      } catch (err) {
        console.log(err)
      }
    },
    async stopUsingCancelEvent(){
      const params = {
        ctmmnyNo: this.$store.state.partnerId,
        mberNo: this.$store.state.mberInfo.mberNo,
        requestId: this.$store.state.mberInfo.mberNo,
        prepaidCardStatus: "ACTIVATION",
        methodName: "PUT"
      }

      const res = await api.updatePrepaidCardStatus(params, { prepaidCardNo: this.$store.state.prepaidCardNo })
        if (res.data.code === "S00000") {
          this.showStopUsingCancelPopup = true;
        } else {
          //사용중지 취소할떄 실패시
          this.alertMessage = res.message;
          this.alertPopup = true;
        }
    },
  }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/stopUsingCancel.scss';
</style>